import { environment } from '@quartz-gov-legacy/environments/environment';

(function () {
    'use strict';

    angular
        .module('adminReferenceDataControllers')
        .factory('adminReferenceDataService', ['$http', '$q', function ($http, $q) {

            var baseUrl = environment.apiUrl + '/Pilot/api/LookupAttribute/Value/';
            var service = {}

            // Get LookupAttributes
            service.getLookupAttributeValues = function (itemTypeCode) {
                var reqUrl = baseUrl + "For/" + itemTypeCode;

                return $http.get(reqUrl)
                            .then(function (response) {
                                return response.data;
                            });
            }

            // Create LookupAttributeValue
            service.addUserDefinedValue = function (itemTypeCode, attributeCode, attributeValue) {
                var reqUrl = baseUrl + "For/" + itemTypeCode + "/And/Code/" + attributeCode;

                return $http.post(reqUrl, { lookupAttributeValue: attributeValue })
                            .then(function (response) {
                                return response.data;
                            });
            }

            // Update LookupAttributeValue
            service.updateUserDefinedValue = function (attributeValueId, attributeValue) {
                var reqUrl = baseUrl + attributeValueId;

                return $http.put(reqUrl, { lookupAttributeValue: attributeValue })
                            .then(function (response) {
                                return response.data;
                            });
            }

            // Delete LookupAttributeValue
            service.deleteUserDefinedValue = function (lookupAttributeValueId) {
                var reqUrl = baseUrl + lookupAttributeValueId;

                return $http.delete(reqUrl)
                            .then(function (response) {
                                return response.data;
                            });
            }

            return service;
        }]);

})();
